export default __webpack_public_path__ + "static/media/edition-2-rot.549896ad.svg";